// F3b: 审批 payload 构造 + 签名 + 序列化。
//
// 与 agent-host 端 approval.rs 字节一致：
//   payload key 字典序: adapter_id, caller_user_id, decision, invocation_id,
//                       prompt_sha256, room_id, ts, version
//   payload_b64 = base64(canonical_json_bytes)
//   signature_b64 = base64(Ed25519(sk, canonical_json_bytes))
//
// 客户端永远不签 prompt 原文 —— 只签 sha256(prompt)，让 agent verify 时
// hash 实际 prompt 必须一致, 防"批准 ls"被换成"批准 rm -rf"。

import { canonicalJson, Ed25519Signer } from "@chatbox/protocol";

import { bytesToBase64 } from "./identity-key";

export interface ApprovalPayload {
  version: 1;
  invocation_id: string;
  caller_user_id: string;
  room_id: string;
  adapter_id: string;
  prompt_sha256: string;
  decision: "approve" | "deny";
  ts: number;
}

export interface SignedApprovalResponse {
  kind: "approval-response";
  invocation_id: string;
  decision: "approve" | "deny";
  payload_b64: string;
  signature_b64: string;
  pubkey_b64: string;
}

/** sha256 hex（与 Rust hex 小写一致）。Web Crypto 原生, 不引第三方依赖。 */
export async function promptSha256Hex(prompt: string): Promise<string> {
  const enc = new TextEncoder().encode(prompt);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  const arr = new Uint8Array(buf);
  let out = "";
  for (const b of arr) out += b.toString(16).padStart(2, "0");
  return out;
}

/** 签名一次审批决定，返回可直接 ws.send 的对象。 */
export function signApproval(
  signer: Ed25519Signer,
  publicKey: Uint8Array,
  payload: ApprovalPayload,
): SignedApprovalResponse {
  const canon = canonicalJson(payload as unknown as Record<string, unknown>);
  const bytes = new TextEncoder().encode(canon);
  const sig = signer.sign(bytes);
  return {
    kind: "approval-response",
    invocation_id: payload.invocation_id,
    decision: payload.decision,
    payload_b64: bytesToBase64(bytes),
    signature_b64: bytesToBase64(sig),
    pubkey_b64: bytesToBase64(publicKey),
  };
}
